// DyreID DPM (2026-10-08): see docs/superpowers/specs/2026-10-08-dyreid-dpm-integration-design.md
// Pure helpers for the DPM drawer close callback. Never mutates its inputs.

export function isDpmPrescription(prescription) {
    return !!(prescription && prescription.source === 'dpm');
}

// existing: what the open journal holds (may include unsaved local entries without id).
// fresh: journal.prescriptions reloaded from the server after the drawer closed.
export function mergeNewPrescriptions(existing, fresh) {
    const current = Array.isArray(existing) ? existing : [];
    const incoming = Array.isArray(fresh) ? fresh : [];
    const knownIds = new Set(current.filter(p => p && p.id).map(p => p.id));
    const added = incoming.filter(p => p && p.id && !knownIds.has(p.id));
    return { merged: [...current, ...added], added };
}
